export default "__VITE_ASSET__CtL82J_l__"